import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStop = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 5,
		y: 5,
		width: 14,
		height: 14
	})
});
export default SvgStop;
